

































import Vue from "vue";
import ConsentGroupOverview from "@/api/models/ConsentGroupOverview";
import Api from "@/api/api";

export default Vue.extend({
  name: "c-consent-group",
  props: {
    group: {
      type: Object as () => ConsentGroupOverview
    },

    customerId: {
      type: Number
    }
  },

  data () {
    return {
      active: false,
      initialConsents: {} as { [consentId: string]: string },
      changedConsents: {} as { [consentId: string]: string }
    };
  },

  methods: {
    onClick () {
      this.active = true;
    },

    async updateConsents () {
      this.$q.loading.show();
      const response = await Api.customer.updateCustomerConsentsAsync(
        (this.group.id !== undefined ? "/api/customer/" + this.customerId + "/action/json/consent/groups/update" : "/api/customer/" + this.customerId + "/action/json/consents/update"),
        {
          /* eslint-disable */
          document_consent_definition_group_id: (this.group.id !== undefined ? this.group.id.toString() : ""),
          /* eslint-enable */
          ...this.changedConsents
        }
      );

      if (response.error) {
        this.$error(response.message || "Si è verificato un errore durante l'aggiornamento dei consensi.");
        this.$q.loading.hide();
        return;
      }

      this.active = false;
      this.$q.loading.hide();
    },

    onConsentChanged (arg: { consent: string; response: string }) {
      this.changedConsents[arg.consent] = arg.response;
    },

    onConsentInitialised (arg: { consent: string; response: string }) {
      this.initialConsents[arg.consent] = arg.response;
    },

    cancelEdit (event: MouseEvent) {
      event.stopPropagation();

      const htmlElement = document.querySelector(`[group-id="${this.group.id}"]`) as HTMLElement;
      window.scrollBy(0, htmlElement.getBoundingClientRect().y - 60);

      const consentElements = this.$refs.consents;
      if (consentElements instanceof Array) {
        (consentElements as unknown as { reset (): void }[]).forEach(consent => consent.reset());
      } else {
        (consentElements as unknown as { reset (): void }).reset();
      }

      this.active = false;
    }
  }
});
